<template>
  <div class="image-uploader">
    <el-upload
      class="uploader"
      action="#"
      :show-file-list="false"
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept="image/*"
    >
      <img v-if="value" :src="value" class="preview-img" alt="" />
      <i v-else class="el-icon-plus uploader-icon"></i>
    </el-upload>
    <div class="uploader-foot">
      <el-button v-if="value" type="text" size="mini" class="remove-btn" @click="handleRemove">移除</el-button>
      <span v-if="tip" class="uploader-tip">{{ tip }}</span>
    </div>
  </div>
</template>

<script>
import { uploadImageApi } from '@/Api/requestApi'

export default {
  name: 'ImageUploader',
  props: {
    value: {
      type: String,
      default: '',
    },
    tip: {
      type: String,
      default: '',
    },
    maxSize: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    beforeUpload(file) {
      const isImage = /^image\//.test(file.type)
      if (!isImage) {
        this.$message({ message: '只能上傳圖片文件', type: 'warning' })
        return false
      }
      const isLt = file.size / 1024 / 1024 < this.maxSize
      if (!isLt) {
        this.$message({ message: `圖片大小不能超過 ${this.maxSize}MB`, type: 'warning' })
        return false
      }
      return true
    },
    async handleUpload(options) {
      const file = options.file
      const formData = new FormData()
      formData.append('file', file)
      try {
        const { data } = await uploadImageApi(formData)
        if (data.code === 200 && data.data) {
          const url = typeof data.data === 'string' ? data.data : data.data.url
          this.$emit('input', url)
          options.onSuccess && options.onSuccess(data)
          return
        }
        throw new Error(data.message || '上傳失敗')
      } catch (err) {
        // 佔位階段：後端接口未就緒時使用本地預覽，保證可視化編輯
        const localUrl = URL.createObjectURL(file)
        this.$emit('input', localUrl)
        this.$message({ message: '上傳接口未就緒，已使用本地預覽', type: 'warning', duration: 1500 })
        options.onError && options.onError(err)
      }
    },
    handleRemove() {
      this.$emit('input', '')
    },
  },
}
</script>

<style lang="scss" scoped>
.image-uploader {
  .uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      overflow: hidden;
      transition: border-color 0.2s;

      &:hover {
        border-color: #409eff;
      }
    }

    .uploader-icon {
      font-size: 24px;
      color: #8c939d;
      width: 148px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }

    .preview-img {
      width: 148px;
      height: 90px;
      display: block;
      object-fit: cover;
    }
  }

  .uploader-foot {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;

    .remove-btn {
      color: #f56c6c;
      padding: 0;
    }

    .uploader-tip {
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
